import React from "react";
export class SelectedCheckIcon extends React.Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { active, className } = this.props;
        const fill = active ? "#C20000" : "#373435";
        return (<svg width="14" height="10" viewBox="0 0 14 10" className={className}>
				<defs>
					<path id="a" d="M0 0h14v14H0z"/>
				</defs>
				<g fill="none" fillRule="evenodd" transform="translate(0 -1.911)">
					<path stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M1 7.762l3.429 3.048L13 3.19" mask="url(#b)"/>
				</g>
			</svg>);
    }
}
